// extracted by mini-css-extract-plugin
export var previewSection = "spaceflight-module--preview-section--fVAXm";
export var video = "spaceflight-module--video--arvMf";
export var container = "spaceflight-module--container--2BMhv";
export var pageTitleWrapper = "spaceflight-module--page-title-wrapper--em3dg";